import { v4 as uuidv4 } from 'uuid'
import { HttpClient } from '@opallabs/api'
import { RelayWebSocket } from '@opallabs/lambda'
import setPresentationId from '../setPresentationId'
import updatePresentationProgress from '../updatePresentationProgress'

const createPresentationRequest = (params) =>
  HttpClient().post('/api/v1/presentation_settings', params)

const getMomentsPresentationSetting = (id) =>
  HttpClient().get(`/api/v1/presentation_settings/${id}`)

const presentationIdFromRelation = (response) =>
  response.data.data.relationships.presentation.data &&
  response.data.data.relationships.presentation.data.id

const setPresentationIdFromResponse = (response, dispatch) => {
  const presentationId = presentationIdFromRelation(response)
  return dispatch(setPresentationId(presentationId))
}

const createPresentation = (params) => (dispatch) => {
  const preChannel = `unsecured_channel_${uuidv4()}`
  const presentationSetting = {
    presentation_setting: { ...params, channel_identifier: preChannel },
  }

  createPresentationRequest(presentationSetting).then((response) => {
    const settingId = response.data.data.id

    const presentationId = presentationIdFromRelation(response)
    dispatch(setPresentationId(presentationId))

    const updateCallback = (args) => {
      dispatch(updatePresentationProgress(args))
      if (parseInt(args, 10) >= 100) {
        getMomentsPresentationSetting(settingId)
          .then((gmResponse) =>
            setPresentationIdFromResponse(gmResponse, dispatch)
          )
          .catch((err) => {
            throw err
          })
      }
    }

    new RelayWebSocket({
      debug: false,
      channels: [preChannel],
      onMessage: updateCallback,
      eventSourceUrl: window.top.location.origin,
    })
  })
}

export default createPresentation
